// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"Landing_landingContainer__n6qbb","imagen":"Landing_imagen__1n0hr","button":"Landing_button__2zcxa","link":"Landing_link__219Bw"};